import Swiper, { Grid, Navigation, Pagination, Thumbs } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

// Configuramos los módulos a usar
Swiper.use([Navigation, Pagination, Thumbs, Grid]);

const SwiperExport = (function () {
	const SwiperLearnMore = () => {
		const _SwiperLearnMore = new Swiper('.SwiperLearnMore', {
			slidesPerView: 1,
			navigation: {
				nextEl: '.SwiperLearnMore-button-next',
				prevEl: '.SwiperLearnMore-button-prev',
			},
		});
	};

	const SwiperAptos = () => {
		const _SwiperAptos = new Swiper('.SwiperAptos', {
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	};

	const SwiperLocation = () => {
		var _SwiperLocation = new Swiper('.SwiperLocation', {
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	};

	return {
		getChildFunctions: function () {
			try {
				SwiperLearnMore();
			} catch (error) {
				console.log(error);
			}
			try {
				SwiperAptos();
			} catch (error) {
				console.log(error);
			}
			try {
				SwiperLocation();
			} catch (error) {
				console.log(error);
			}
		},
	};
})();

const getChildsSwiper = () => {
	SwiperExport.getChildFunctions();
};

export { getChildsSwiper };
